import { render, staticRenderFns } from "./CompareModal2.vue?vue&type=template&id=594d941c"
import script from "./CompareModal2.vue?vue&type=script&lang=js"
export * from "./CompareModal2.vue?vue&type=script&lang=js"
import style0 from "./CompareModal2.vue?vue&type=style&index=0&id=594d941c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports